import { useEffect, useState } from "react";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, { animationCleanUp } from "./animation";
import assets from "./assets";
import "./style/style.scss";
import "./style/animation.scss";
import getContentById from "../../../../shared/utils/getContentById";
import parseMediaUrl from "../../../../shared/functions/parseMediaUrl";
import TeamLogo from "../../_partials/TeamLogo";
import textImage from "./images/mainText_v.webp";
import textImageWhite from "./images/mainText_white.webp";
import textImageGray from "./images/mainText_gray.webp";
import textImageGray916 from "./images/mainText_gray-9-16.webp";
import textImageWhite916 from "./images/mainText_white_9-16.webp";
import _, { initial, template } from "lodash";
import Functions from "../../../../shared/components/MediaLibrary/EditModal/functions";
import {
  getWrapperDimensions,
} from "../../../../shared/components/MediaLibrary/EditModal/ImageEditorModal";
import BlackPlayer from "./images/blackPlayer_small.webp";
import GreenPlayer from "./images/greenPlayer_small.webp";
import FCBPlayerImage from "../../../../shared/components/Image/FCBPlayerImage";
import { GKPresetColors } from "../../../../shared/components/MediaLibrary/EditModal/LeftSidebar/EditTab";
import { DEFAULT_ADJUSTMENTS } from "../../../constants/constants";
import { reorderPlayers } from "./LineupForEdit";


const PlayerCard = ({ player, presetClass, presetGkColor, index, isSubstitute = false, lang = 'en' }) => {
  const hasPlayer = !!player;
  return (
    <div
      className={`player-card ${isSubstitute ? "substitute-card" : "main-card"} ${lang === 'ar' ? "player-ar" : ""}`}
    >
      <div className="player-image-container">
        {hasPlayer ? (
          <FCBPlayerImage player={player} presetClass={presetClass} gkPreset={presetGkColor} />
        ) : (
          <div className="player-image-placeholder"></div>
        )}
      </div>

      <div className="player-info">
        <div className="jersey-number">
          <div className="jersey-number">
            <div>{hasPlayer ? player?.shirtNumber : ""}</div>
            {hasPlayer ? (
              <span className="outline_no">{player?.shirtNumber}</span>
            ) : null}
          </div>
        </div>
        <div className="player-name">
          {hasPlayer
            ? lang === "ar" ? player?.arabicName : player?.shortLastName?.toUpperCase() || player?.label?.toUpperCase() : ""}
        </div>
      </div>
    </div>
  );
};

const Index = ({ animation, data, mode, format, _searchParams, ...props }) => {
  const templateName = data?.template_name ?? "";
  const id = `${templateName}_${data?.uuid}`;

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          id,
          data,
          format,
          apiSetup: props?.apiSetup,
          templateName: data?.template_name,
        });
      }
    }

    if (mode === "screenshot") {
      const videoBg = $(`#${id} video.custom-background`).get(0);
      if (videoBg) {
        videoBg.addEventListener(
          "loadedmetadata",
          function () {
            this.currentTime = 3;
            this.pause();
          },
          false,
        );
      }
    }

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const { options, fields, dynamic, editData } = data?.data || {};
  const _initialLayers = editData?.layers;
  const manualEntries = editData?.manualEntries;

  const _lastLayer = _initialLayers?.[_initialLayers?.length - 1];
  let _initialPreset = "";
  if (_lastLayer?.isPreset && _lastLayer?.isColor) {
    const bg = _lastLayer.backgroundUrl;
    if (bg === "#ad042b") {
      _initialPreset = "red";
    } else if (bg === "#111111") {
      _initialPreset = "black";
    } else {
      _initialPreset = "gray";
    }
  } else {
    _initialPreset = "gray";
  }
  const [presetClass, setPresetClass] = useState(_initialPreset);
  const { matchDetails = {}, teamSide } = data?.data?.dynamic || {};

  const liveLineup = _.get(dynamic, "lineup");

  const customLineupPlayers = getContentById("lineup_players", fields);
  const customLineupPlayersData = getContentById(
    "lineup_players",
    fields,
    "data",
  );
  const customLineup = [...customLineupPlayersData, ...manualEntries]?.filter((player) =>
    customLineupPlayers.includes(player?.id),
  );

  const customAdditionalLineup = getContentById("additional_lineup", fields);
  customAdditionalLineup?.map((element) => {
    if (element) {
      customLineup.push({
        shirtNumber: element.shirtNumber,
        label: element.label,
      });
    }
  });

  const sortedCustomLineup = [...customLineup];
  sortedCustomLineup.sort((a, b) => a.shirtNumber - b.shirtNumber);

  const customReservePlayers = getContentById("reserve_players", fields);
  const customReservePlayersData = getContentById(
    "reserve_players",
    fields,
    "data",
  );
  const customReserve = [...customReservePlayersData, ...manualEntries]?.filter((player) =>
    customReservePlayers?.includes(player?.id),
  );
  const customAdditionalReserve = getContentById("additional_reserve", fields);
  customAdditionalReserve?.map((element) => {
    if (element) {
      customReserve.push({
        shirtNumber: element.shirtNumber,
        label: element.label,
      });
    }
  });

  const imageSide = getContentById("imageSide", fields) || "left";
  const homeTeam = data?.event?.home;
  const awayTeam = data?.event?.away;
  const competitionId = data?.event?.competitionId;

  const fcbTeam = homeTeam?.id === "apoawtpvac4zqlancmvw4nk4o" ? homeTeam : awayTeam;

  const liveLineupData =
    teamSide === "home"
      ? _.find(liveLineup, { contestantId: homeTeam?.id })
      : _.find(liveLineup, { contestantId: awayTeam?.id });

  const sortedLiveLineupData = liveLineupData;
  sortedLiveLineupData?.player.sort((a, b) => a.shirtNumber - b.shirtNumber);

  const playerList = _.get(liveLineupData, "player");

  const customBackground = getContentById("background", fields, "self");
  const customBackgroundStyles = _.get(
    customBackground,
    `styles.${format}`,
    {},
  );
  const [layers, setLayers] = useState([]);
  const defaultEffects = {
    isBlur: false,
    isOpacity: false,
    isGradient: false,
    isShadow: false,
    resize: 100,
    ratio: 0,
    ratioUrl: "",
    prevRatio: 0,
    gkPreset: GKPresetColors.red,
  };
  const [effects, setEffects] = useState(defaultEffects);
  const [presetGkColor, setPresetGkColor] = useState(GKPresetColors.red)
  useEffect(() => {
    const initialLayers = editData?.layers;
    const initialEffects = editData?.effects;

    if (initialLayers) {
      setTimeout(() => {
        setLayers(initialLayers);
        setEffects(initialEffects ?? effects);
        if (initialEffects?.ratio > 0) {
          // prevRatioRef.current = initialEffects?.ratio;
          if (initialEffects) {
            setPresetGkColor(initialEffects.gkPreset);
          }
        }
      }, 100);
    }
    if (!initialLayers && !editData) {
      const getBackgroundUrls = () => {
        const background = getContentById("background", fields, "self");
        const values = background?.value;
        if (!Array.isArray(values)) return [];

        return values.map((val) => parseMediaUrl(_.get(val, "url", "")));
      };
      const backgroundUrls = getBackgroundUrls();
      const initializeLayers = async () => {
        const newLayerPromises = backgroundUrls.map(async (url, index) => {
          const functions = new Functions(url);
          const finalUrl = functions.getUrl();
          const newDimension = getWrapperDimensions(effects.ratio);
          const newLayer = {
            id: Date.now() + index,
            imageUrl: finalUrl,
            backgroundUrl: url,
            functions,
            dimensions: {
              width: newDimension.width,
              height: newDimension.height,
            },
            originalDimensions: {
              width: newDimension.width,
              height: newDimension.height,
            },
            nonRatioDimensions: {
              width: newDimension.width,
              height: newDimension.height,
            },
            adjustments: DEFAULT_ADJUSTMENTS,
            x: 0,
            y: 0,
            nonRatioX: 0,
            nonRatioY: 0,
            zIndex: index + 1,
            backgroundAndResize: {
              removebg: false,
              removebgUrl: "",
              changebg: false,
              changebgUrl: "",
            },
            isResizing: false,
            isRecreated: false,
          };

          return newLayer;
        });

        const addedLayers = await Promise.all(newLayerPromises);

        setLayers(addedLayers);
        setEffects(defaultEffects);
      };
      initializeLayers();
    }
  }, [editData, fields, format]);

  // Get main players and substitutes
  const mainPlayers =
    sortedCustomLineup?.length > 0
      ? sortedCustomLineup
      : sortedLiveLineupData?.player?.filter(
        (p) => p.position !== "Substitute",
      ) || [];

  const substitutePlayers =
    customReserve?.length > 0
      ? customReserve
      : liveLineupData?.player?.filter((p) => p.position === "Substitute") ||
      [];
  const keepersFromSub = substitutePlayers.filter((p) => p.position === 'Goalkeeper');
  const excludeKeepersFromSub = substitutePlayers.filter((p) => p.position !== 'Goalkeeper');
  excludeKeepersFromSub?.sort((a, b) => a.shirtNumber - b.shirtNumber);

  let normalizedPlayers = [...mainPlayers];
  while (normalizedPlayers.length < 11) {
    normalizedPlayers.push(null);
  }
  normalizedPlayers = reorderPlayers(normalizedPlayers);
  useEffect(() => {
    if (layers.length > 0) {
      const lastLayer = layers[layers.length - 1];
      if (lastLayer?.isPreset && lastLayer?.isColor) {
        const bg = lastLayer.backgroundUrl;
        if (bg === "#ad042b") {
          setPresetClass("red");
        } else if (bg === "#111111") {
          setPresetClass("black");
        } else {
          setPresetClass("gray");
        }
      } else {
        setPresetClass("gray");
      }
    }
  }, [layers, format]);

  // TODO:
  // how to get the updated lineup content ???
  // console.log('templateData: ', [...customLineupPlayersData, ...manualEntries])
  const templateLang = data.lang;
  return (
    <div
      id={id}
      className={`T_${templateName} ${presetClass} ${animation ? "animation" : ""} newTemplate image-side-${imageSide}`}
    >
      <TemplateBlock>
        <div className={`custom-background-container ${effects?.hasCLStars ? "" : "no-cl"}`}>
          <div
            id={_.get(customBackground, "id", null)}
            style={{ ...customBackgroundStyles }}
            className={"custom-background"}
          ></div>
        </div>

        <div className="mainCard-content">
          <div className="mainCard-content-text">
            <img
              src={
                presetClass === "red"
                  ? format === "1080x1920"
                    ? textImageWhite
                    : format === '1200x1500' ? textImageWhite : textImageWhite
                  : presetClass === "gray"
                    ? format === "1080x1920"
                      ? textImageGray916
                      // : textImageGray
                      : textImageGray916
                    : format === "1080x1920" ? textImageGray : textImageGray
              }
              alt="textImage"
            />
          </div>
          <div className={`wc-content content`} style={{ zIndex: 101 }}>
            {/* Main Lineup Section */}
            <div className="lineup-section">
              <div className="lineup-section-heading">
                {/* Team Logos */}
                <div className={`logo-container`}>
                  <div className={`home`}>
                    <TeamLogo team={homeTeam} competitionId={competitionId} />
                  </div>
                  <div className={`away`}>
                    <TeamLogo team={awayTeam} competitionId={competitionId} />
                  </div>
                </div>
                <div className="lineup-title">
                  <div>XI</div>
                  <span class="outlineText">XI</span>
                </div>
              </div>
              {/* <div className="main-players-grid"> */}
              {normalizedPlayers?.map((player, index) => (
                <PlayerCard
                  key={`player-slot-${index}-${player?.id || "empty"}`}
                  player={player}
                  presetClass={presetClass}
                  index={index}
                  presetGkColor={presetGkColor}
                  lang={templateLang}
                />
              ))}
              {/* </div> */}
            </div>

            {/* Substitutes Section */}
            {substitutePlayers.length > 0 && (
              <div className="substitutes-section">
                <div className={`substitutes-list ${templateLang === 'ar' ? "substitues-ar" : ""}`}>
                  {/* keepersFromSub */}
                  {keepersFromSub.map((player, index) => (
                    <span
                      key={`sub-${player?.shirtNumber || index}`}
                      className="substitute-name"
                    >
                      {templateLang === 'ar' ? player?.arabicName : player?.shortLastName?.toUpperCase() || player?.label?.toUpperCase()}
                      {index < keepersFromSub.length - 1 && (templateLang === 'ar' ? "، " : ", ")}
                    </span>
                  ))}
                  {keepersFromSub.length > 0 ? <span> - </span> : <span />}
                  {excludeKeepersFromSub.map((player, index) => (
                    <span
                      key={`sub-${player?.shirtNumber || index}`}
                      className="substitute-name"
                    >
                      {templateLang === 'ar' ? player?.arabicName : player?.shortLastName?.toUpperCase() || player?.label?.toUpperCase()}
                      {index < excludeKeepersFromSub.length - 1 && (templateLang === 'ar' ? "، " : ", ")}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </TemplateBlock>
    </div>
  );
};

export default Index;
